<template>
  <div style="width: 100%">
    <div style="margin: 20px">
      <h4>申请内容:</h4>
      <div class="box">
        <el-form label-width="140px" :disabled="disabledFlag">
          <el-row>
            <el-col :span="10" :offset="1">
              <el-form-item label="报销月份：" required>
                <el-date-picker
                    v-model="reimburse_month"
                    style="width: 100%"
                    type="month"
                    value-format="YYYY-MM"
                    placeholder="报销月份">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="日期范围：" required v-if="!disabledFlag">
                <el-date-picker
                    v-model="reimburse_date_range"
                    type="daterange"
                    range-separator="至"
                    value-format="YYYY-MM-DD"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="1" :offset="1">
              <el-button type="primary" plain @click="searchButton" v-if="!disabledFlag">搜索</el-button>
            </el-col>
          </el-row>
        </el-form>
        <h4 class="table-desc-style">费用明细:</h4>
        <el-table
            ref="multipleTable"
            :data="feeTable"
            border
            stripe
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange">
          <el-table-column
              type="selection"
              align="center"
              :selectable="isSelectable"
              width="55"
          >
          </el-table-column>
          <el-table-column
              label="流程单号"
              align="center"
              prop="process_id">
          </el-table-column>
          <el-table-column
              align="center"
              label="日期"
              prop="start_date">
          </el-table-column>
          <el-table-column
              prop="process_type"
              align="center"
              label="类型"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              prop="name"
              align="center"
              label="客户/本司"
              width="450"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              prop="money"
              align="center"
              label="汇总金额(元)"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              align="center"
              label="操作">
            <template #default="scope">
              <el-button
                  size="small"
                  link
                  type="primary"
                  @click="feeDetail(scope.$index, scope.row)"
                  v-if="scope.row.process_type !== '客户费用' && scope.row.process_type !== '本司费用'"
              >
                详细
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog
            v-model="detailDialogVisible"
            title="详细"
            width="900"
            :before-close="closeDetail"
        >
          <h4>{{ detailTitle }}</h4>
          <el-table
              ref="detailTableMultipleTable"
              :data="detailTable"
              tooltip-effect="dark">
            <el-table-column
                type=index
                align="center"
                label="序号"
                width="55">
            </el-table-column>
            <el-table-column
                prop="itemName"
                label="项目"
                width="100"
                align="center">
            </el-table-column>
            <el-table-column
                align="center"
                label="金额(元)">
              <template #default="scope">
                <el-input-number v-model="scope.row.money" controls-position="right" :min="0"
                                 step="100" :disabled="disabledFlag"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                width="400"
                label="备注">
              <template #default="scope">
                <el-input v-model="scope.row.remark" :disabled="disabledFlag"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <template #footer>
            <div>
              <el-button @click="editDetail">保存</el-button>
              <el-button @click="closeDetail">关闭</el-button>
            </div>
          </template>
        </el-dialog>

        <!-- 合计行 -->
        <div class="total-row">
          <span class="total-label">合计金额：</span>
          <span class="total-value">{{ feeTotalMoneyStr }}</span>
        </div>

        <h4 class="table-desc-style">出差发票明细:</h4>
        <!--        <el-table
                    row-key="item"
                    ref="businessTripInvoiceMultipleTable"
                    :data="businessTripInvoiceTable"
                    tooltip-effect="dark">
                  <el-table-column
                      type=index
                      align="center"
                      label="序号"
                      width="55">
                  </el-table-column>
                  <el-table-column
                      prop="item_name"
                      label="项目"
                      align="center">
                  </el-table-column>
                  <el-table-column
                      prop="money"
                      align="center"
                      label="汇总金额(元)">
                  </el-table-column>
                  <el-table-column align="center" label="实际金额(元)">
                    <template #default="scope">
                      <el-input-number v-model="scope.row.actual_money" controls-position="right" :min="0"
                                       step="100" :disabled="disabledFlag"
                                       @change="actualMoneyChange(scope.row)"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="发票张数">
                    <template #default="scope">
                      <el-input-number v-model="scope.row.invoice_num" controls-position="right" :min="0"
                                       :disabled="disabledFlag"></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="备注" width="400">
                    <template #default="scope">
                      <el-input v-model="scope.row.remark" :disabled="disabledFlag"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column type="expand" align="center" label="发票详细" width="100">
                    <template #default="scope">
                      {{scope.row.item}}
                      <el-col :span="10" :offset="1">
                        <kf-file-download v-if="disabledFlag" :file-list="scope.row.fileListObj"></kf-file-download>
                        <kf-file-upload v-else v-model="scope.row.fileList" :key="scope.row.item"
                                         :init-file="scope.row.fileListObj"
                                        accept=".pdf"
                                         @fileChange="businessTripInvoiceFileListChange($event, scope.row)" :limit="20"/>
                      </el-col>
                    </template>
                  </el-table-column>
                </el-table>-->
        <div>
          <!-- 表头 -->
          <div class="table-header">
            <div class="header-cell" style="width: 55px;">序号</div>
            <div class="header-cell">项目</div>
            <div class="header-cell">汇总金额(元)</div>
            <div class="header-cell">实际金额(元)</div>
            <div class="header-cell">发票张数</div>
            <div class="header-cell" style="width: 400px;">备注</div>
            <div class="header-cell" style="width: 100px;">发票详细</div>
          </div>

          <!-- 表格内容 -->
          <div class="table-body">
            <div class="table-row" v-for="(row, index) in businessTripInvoiceTable" :key="row.item">
              <!-- 主行内容 -->
              <div class="row-content">
                <div class="row-cell" style="width: 55px;">{{ index + 1 }}</div>
                <div class="row-cell">{{ row.item_name }}</div>
                <div class="row-cell">{{ row.money }}</div>
                <div class="row-cell">
                  <el-input-number
                      v-model="row.actual_money"
                      controls-position="right"
                      :min="0"
                      step="100"
                      :disabled="disabledFlag"
                      @change="actualMoneyChange(row)"
                  ></el-input-number>
                </div>
                <div class="row-cell">
                  <el-input-number
                      v-model="row.invoice_num"
                      controls-position="right"
                      :min="0"
                      :disabled="disabledFlag"
                  ></el-input-number>
                </div>
                <div class="row-cell" style="width: 400px;">
                  <el-input v-model="row.remark" :disabled="disabledFlag"></el-input>
                </div>
                <div class="row-cell" style="width: 100px;">
                  <el-button @click="toggleExpand(row)">{{ row.expanded ? '收起' : '展开' }}</el-button>
                </div>
              </div>

              <!-- 展开部分 -->
              <div class="expand-row" v-show="row.expanded">
                <div class="expand-content">
                  <el-form-item label="注意:" label-width="100">
                    <el-text class="mx-1" type="danger">请上传pdf文件格式的发票，可单独上传也可合并后上传，每次上传至多20个文件</el-text>
                  </el-form-item>
                  <el-col :span="6" :offset="1">
                    <div v-for="(file,index) in row.fileListObj" :key="index">
                      <el-link type="primary" @click="handleFileClick(row.fileListObj,index)">
                        {{ getFileName(file, index) }}
                      </el-link>
                    </div>
                    <!--                    <el-link
                                            v-if="disabledFlag && (row.fileListObj != null && row.fileListObj.length > 0)"
                                            :file-list="row.fileListObj"
                                            :preview="false"
                                            @click.prevent="handleFileClick(row.fileListObj)"
                                        ></el-link>-->
                    <kf-file-upload
                        v-if="!disabledFlag"
                        v-model="row.fileList"
                        :key="row.item"
                        :init-file="row.fileListObj"
                        accept=".pdf"
                        @fileChange="businessTripInvoiceFileListChange($event, row)"
                        :limit="20"
                    />
                  </el-col>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!--        <el-row>
                  <el-col :span="10" :offset="1">
                    <el-form-item label="注意:" label-width="140">
                      <el-text class="mx-1" type="danger">请将发票文件放在同一文件夹压缩为zip格式上传</el-text>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form label-width="140px" :disabled="disabledFlag">
                  <el-row>
                    <el-col :span="10" :offset="1">
                      <el-form-item label="出差发票:">
                        <kf-file-download v-if="disabledFlag" :preview="false" :file-list="businessTripInvoiceFileListObj">
                        </kf-file-download>
                        <kf-file-upload v-else @fileChange="businessTripInvoiceFileListChange"
                                        accept=".zip"
                                        limit="1"
                                        v-model="businessTripInvoiceFileList"
                                        :init-file="businessTripInvoiceFileListObj">
                        </kf-file-upload>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>-->

        <!-- 合计行 -->
        <div class="total-row">
          <span class="total-label">合计金额：</span>
          <span class="total-value">{{ businessTripInvoiceTotalMoneyStr }}</span>
        </div>
        <h4 class="table-desc-style">费用报销明细:</h4>
        <el-table
            row-key="id"
            ref="feeReimburseMultipleTable"
            :data="feeReimburseTable"
            tooltip-effect="dark"
            style="width: 100%">
          <el-table-column
              type=index
              align="center"
              label="序号"
              width="55">
          </el-table-column>
          <el-table-column
              align="center"
              prop="cost_name"
              label="费用类型">
          </el-table-column>
          <!--          <el-table-column type="expand" align="center" label="发票详细" width="100">
                      <template #default="scope">
                        <div>
                          <kf-image-viewer :image-list="scope.row.fileListObj"></kf-image-viewer>
                        </div>
                      </template>
                    </el-table-column>-->
          <el-table-column
              prop="money"
              align="center"
              label="实际金额(元)">
          </el-table-column>
          <!--          <el-table-column
                        prop="invoice_num"
                        align="center"
                        label="发票张数"
                        show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="备注"
                        width="400"
                        show-overflow-tooltip>
                      <template #default="scope">
                        <el-input v-model="scope.row.remark" :disabled="disabledFlag"></el-input>
                      </template>
                    </el-table-column>-->
          <!--          <el-table-column type="expand" align="center" label="发票详细" width="100">
                      <template #default="scope">
                        <div>
                          <kf-image-viewer :image-list="scope.row.fileListObj"></kf-image-viewer>
                        </div>
                      </template>
                    </el-table-column>-->
        </el-table>
        <h4>费用报销发票:</h4>
        <div style="margin-left: 5%">
          <div v-for="(file,index) in feeReimburseFileListObj" :key="index">
            <el-link type="primary" @click="handleFileClick(feeReimburseFileListObj,index)">{{
                getFileName(file, index)
              }}
            </el-link>
          </div>
        </div>
        <!--                <kf-file-download
                            v-if="feeReimburseFileListObj != null && feeReimburseFileListObj.length > 0"
                            :file-list="feeReimburseFileListObj"
                            :preview="false"
                            @click="handleFileClick(feeReimburseFileListObj)"
                        ></kf-file-download>-->

        <!-- 合计行 -->
        <div class="total-row">
          <span class="total-label">合计金额：</span>
          <span class="total-value">{{ feeReimburseTotalMoneyStr }}</span>
        </div>
      </div>
      <div class="total-row">
        <span class="total-label">报销金额总计：</span>
        <span class="total-value">{{ reimburseMoneyStr }}</span>
      </div>

      <div style="display: flex;justify-content: center;margin-bottom: 20px" v-if="!disabledFlag">
        <el-button v-loading.fullscreen.lock="loading" type="primary" @click="confirmButton">提交</el-button>
      </div>
    </div>

  </div>
</template>

<script>

import {Plus} from "@element-plus/icons-vue";
import numeral from 'numeral';

export default {
  name: "MonthReimburseTestXu",
  components: {Plus},
  inject: ['$fn'],
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      feeReimburseFileList: [],
      feeReimburseFileListObj: [],
      businessTripInvoiceFileListObj: [],
      rowSelectingFlag: false,
      loading: false,
      detailTitle: '',
      detailDialogVisible: false,
      reimburse_month: '',
      //详细
      detailTable: [],
      //费用
      feeTable: [],
      //出差发票
      businessTripInvoiceTable: [{
        item: 'oil_cost',
        item_name: '油费',
        money: 0.00,
        invoice_num: 0,
        fileList: [],
        fileListObj: [],
        remark: ''
      }, {
        item: 'toll',
        item_name: '通行费',
        money: 0.00,
        invoice_num: 0,
        remark: ''
      }, {
        item: 'parking_fee',
        item_name: '停车费',
        money: 0.00,
        invoice_num: 0,
        remark: ''
      }, {
        item: 'transport_cost',
        item_name: '交通费',
        money: 0.00,
        invoice_num: 0,
        remark: ''
      }, {
        item: 'room_cost',
        item_name: '住宿费',
        money: 0.00,
        invoice_num: 0,
        remark: ''
      }],
      prc_reimburse_ids: [],
      //费用报销
      feeReimburseTable: [],
      reimburse_date_range: [],
      disabledFlag: false,
      containerId: new Date().getTime(),
      feeTotalMoneyStr: '0.00',
      businessTripInvoiceTotalMoneyStr: '0.00',
      feeReimburseTotalMoneyStr: '0.00',
      reimburseMoneyStr: '0.00',
      currentDetailRow: {},
      flagRow: {},
      currentPdfUrl: '',
    };
  },
  mounted() {
    if (this.parentData.button_id === 'prc_reimburse_apply_detail') {
      this.disabledFlag = true;
      this.getReviewData();
    }
  },

  methods: {
    // 点击文件时触发
    handleFileClick(fileListObj, index) {
      let windowObj = {}
      windowObj.component = 'oa/ReimbursePdfView.vue';
      windowObj.parentData = {
        fileListObj: fileListObj,
        index: index
      };
      windowObj.name = "PDF预览";
      windowObj.max = true
      this.$store.dispatch('core/openWindow', windowObj)
    },
    getFileName(file, index) {
      return file.original_name || file.name || `未命名文件${index + 1}`
    },
    actualMoneyChange(row) {
      if (row.actual_money > row.money) {
        row.actual_money = row.money;
        this.$message.error('实际金额不能大于汇总金额');
      }
    },
    async feeDetail(index, row) {
      this.currentDetailRow = row;
      this.flagRow = JSON.parse(JSON.stringify(row));
      this.detailTitle = row.name;
      this.detailDialogVisible = true;
      this.detailTable = this.currentDetailRow.reimburse_item;
    },
    closeDetail() {
      if (this.currentDetailRow.reimburse_item != null && this.currentDetailRow.reimburse_item.length > 0) {
        for (let i = 0; i < this.currentDetailRow.reimburse_item.length; i++) {
          this.currentDetailRow.reimburse_item[i].money = this.flagRow.reimburse_item[i].money;
          this.currentDetailRow.reimburse_item[i].remark = this.flagRow.reimburse_item[i].remark;
        }
      }
      this.detailDialogVisible = false;
    },
    editDetail() {
      this.detailDialogVisible = false;
      this.detailMoneyChange()
      this.$message.success('保存成功');
    },
    detailMoneyChange() {
      this.currentDetailRow.money = 0;
      this.currentDetailRow.reimburse_item.forEach(item => {
        this.currentDetailRow.money = (item.money * 100 + this.currentDetailRow.money * 100) / 100;
      })
      this.businessTripInvoiceTable.forEach(item => {
        item.money = 0
        item.actual_money = 0
      })

      this.feeTable.forEach(row => {
        if (row.is_selected && !row.process_id.startsWith('CA')) {
          row.reimburse_item.forEach((reimburseItem) => {
            switch (reimburseItem.item) {
              case 'oil_cost':
                this.businessTripInvoiceTable[0].money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[0].money * 100) / 100;
                this.businessTripInvoiceTable[0].actual_money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[0].actual_money * 100) / 100;
                break;
              case 'toll':
                this.businessTripInvoiceTable[1].money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[1].money * 100) / 100;
                this.businessTripInvoiceTable[1].actual_money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[1].actual_money * 100) / 100;
                break;
              case 'parking_fee':
                this.businessTripInvoiceTable[2].money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[2].money * 100) / 100;
                this.businessTripInvoiceTable[2].actual_money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[2].actual_money * 100) / 100;
                break;
              case 'transport_cost':
                this.businessTripInvoiceTable[3].money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[3].money * 100) / 100;
                this.businessTripInvoiceTable[3].actual_money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[3].actual_money * 100) / 100;
                break;
              case 'room_cost':
                this.businessTripInvoiceTable[4].money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[4].money * 100) / 100;
                this.businessTripInvoiceTable[4].actual_money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[4].actual_money * 100) / 100;
                break;
              default:
                break;
            }
          });
        }
      })
    },
    isSelectable(row, index) {
      return !this.disabledFlag;
    },
    businessTripInvoiceFileListChange(ids, row) {
      if (ids.length <= 0) {
        row.fileList = [];
        return;
      }
      row.fileList = ids;
    },
    async feeReimburseFileListChange(ids) {
      if (ids.length <= 0) {
        this.feeReimburseFileList = []
        return;
      }
      this.feeReimburseFileList = ids;
    },

    async confirmButton() {
      this.loading = true;
      /*
      if (this.reimburseMoney <= 0) {
        this.$message.error('至少选择一项报销项');
        this.loading = false;
        return
      }*/
      let params = {
        template_code: 'prc_monthly_reimbursement', //这里要加模板code，为什么不用id，因为考虑到有版本
        reimburseMoney: this.reimburseMoney,
        businessTripInvoiceTable: this.businessTripInvoiceTable,
        feeReimburseTable: this.feeReimburseTable,
        feeTable: this.feeTable,
        reimburse_month: this.reimburse_month,
        reimburse_date_range: this.reimburse_date_range,
        prc_reimburse_ids: this.prc_reimburse_ids,
        businessTripInvoiceFileList: this.businessTripInvoiceFileList,
        feeReimburseFileListObj: this.feeReimburseFileListObj,
      }
      //============================================================================================================///
      await this.$http('frameProcessService.createProcess', params, false).then(() => {
        this.$message.success('提交成功');
        this.$fn.closeWindow();
        this.loading = false;
      }, errMsg => {
        this.$message.error(errMsg);
        this.loading = false;
        console.log('aa')
      })
    },
    async searchButton() {
      if (this.reimburse_month == null || this.reimburse_date_range == null || this.reimburse_month === '' || this.reimburse_date_range === '') {
        this.$message.error('请选择报销月份和日期范围');
        return;
      }
      let params = {
        reimburse_month: this.reimburse_month,
        reimburse_date_range: this.reimburse_date_range,
      };
      await this.$http('oaReimburseService.getPrcReimburseData', params).then(res => {
        this.feeTable = res.feeTable
        this.feeTable.forEach(item => {
          if (item.reimburse_item != null) {
            item.reimburse_item = JSON.parse(item.reimburse_item);
          }
        })
      })
    },
    async getReviewData() {
      this.process_id = this.parentData.process_id;
      let params = {
        process_id: this.process_id,
      };
      await this.$http('oaReimburseService.getMonthReimburseReviewData', params).then(res => {
        this.reimburse_month = res.reimburse_month;
        this.reimburse_date_range = res.reimburse_date_range;
        /*let parseRes = JSON.parse(res.reimburse_info)*/
        this.feeTable = res.reimburse_info.feeTable
        this.feeReimburseTable = res.reimburse_info.feeReimburseTable
        this.businessTripInvoiceTable = res.reimburse_info.businessTripInvoiceTable
        this.feeReimburseFileListObj = res.reimburse_info.feeReimburseFileListObj
        // 数据回显：根据 is_selected 设置选中状态
        this.$nextTick(() => {
          this.rowSelectingFlag = true;
          this.feeTable.forEach((row) => {
            if (row.is_selected) {
              this.$refs.multipleTable.toggleRowSelection(row, true);
            }
          });
          this.rowSelectingFlag = false;
        });
      });
    },
    handleSelectionChange(val) {
      if (this.rowSelectingFlag) {
        return;
      }
      this.businessTripInvoiceTable.forEach((item) => {
        item.money = 0.00; // 重置发票表金额
        item.actual_money = 0.00; // 重置发票表实际金额
      });

      this.multipleSelection = val;
      this.prc_reimburse_ids = []
      // 更新 feeTable 中每一行的 is_selected 字段
      this.feeTable.forEach((row) => {
        row.is_selected = val.includes(row); // 如果当前行在选中行中，则设置为 true，否则为 false
      });
      this.feeReimburseTable = [];
      // 计算选中行的总金额和发票表金额
      this.feeReimburseFileListObj = [];
      /*let map = new Map();*/
      val.forEach((item) => {
        this.prc_reimburse_ids.push(item.id)
        if (item.money != null && item.money !== 0) {
          if (item.process_id.startsWith('CA')) {
            if (item.file_list_obj != null && item.file_list_obj.length > 0) {
              item.file_list_obj.forEach((file) => {
                this.feeReimburseFileListObj.push(file)
              })
            }
            item.cost_items.forEach(item =>{
              this.feeReimburseTable.push(item)
            })
            /*item.cost_items.forEach((item) => {
              if (map.has(item.cost_name)) {
                const existingCostDetail = map.get(item.cost_name);
                existingCostDetail.money += item.money;
              } else {
                map.set(item.cost_name, item)
              }
            })
            this.feeReimburseTable = Array.from(map.values())*/
          } else {
            item.reimburse_item.forEach((reimburseItem) => {
              switch (reimburseItem.item) {
                case 'oil_cost':
                  this.businessTripInvoiceTable[0].money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[0].money * 100) / 100;
                  this.businessTripInvoiceTable[0].actual_money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[0].actual_money * 100) / 100;
                  break;
                case 'toll':
                  this.businessTripInvoiceTable[1].money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[1].money * 100) / 100;
                  this.businessTripInvoiceTable[1].actual_money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[1].actual_money * 100) / 100;
                  break;
                case 'parking_fee':
                  this.businessTripInvoiceTable[2].money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[2].money * 100) / 100;
                  this.businessTripInvoiceTable[2].actual_money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[2].actual_money * 100) / 100;
                  break;
                case 'transport_cost':
                  this.businessTripInvoiceTable[3].money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[3].money * 100) / 100;
                  this.businessTripInvoiceTable[3].actual_money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[3].actual_money * 100) / 100;
                  break;
                case 'room_cost':
                  this.businessTripInvoiceTable[4].money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[4].money * 100) / 100;
                  this.businessTripInvoiceTable[4].actual_money = (reimburseItem.money * 100 + this.businessTripInvoiceTable[4].actual_money * 100) / 100;
                  break;
                default:
                  break;
              }
            });
          }
        }
      });
    },
    toggleExpand(row) {
      row.expanded = !row.expanded;
    },
  },


  created() {

  },
  computed: {
    costTypeList() {
      return this.$store.getters['core/getDictList']('cost_name');
    },
    feeTotalMoney() {
      return this.feeTable.reduce((sum, row) => {
        const money = parseFloat(row.money) * 100; // 确保 money 是数值类型
        return isNaN(money) ? sum : sum + money;
      }, 0) / 100;
    },
    businessTripInvoiceTotalMoney() {
      return this.businessTripInvoiceTable.reduce((sum, row) => {
        const money = parseFloat(row.actual_money) * 100; // 确保 money 是数值类型
        return isNaN(money) ? sum : sum + money;
      }, 0) / 100;
    },
    feeReimburseTotalMoney() {
      return this.feeReimburseTable.reduce((sum, row) => {
        const money = parseFloat(row.money) * 100; // 确保 money 是数值类型
        return isNaN(money) ? sum : sum + money;
      }, 0) / 100;
    },
    reimburseMoney() {
      const feeReimburseTotal = this.feeReimburseTotalMoney;
      const businessTripInvoiceTotal = this.businessTripInvoiceTotalMoney;
      return ((isNaN(feeReimburseTotal) ? 0 : feeReimburseTotal) * 100 +
          (isNaN(businessTripInvoiceTotal) ? 0 : businessTripInvoiceTotal) * 100) / 100;
    },
  },
  watch: {
    feeTotalMoney(newVal) {
      this.feeTotalMoneyStr = numeral(newVal).format('0,0.00');
    },
    businessTripInvoiceTotalMoney(newVal) {
      this.businessTripInvoiceTotalMoneyStr = numeral(newVal).format('0,0.00');
    },
    feeReimburseTotalMoney(newVal) {
      this.feeReimburseTotalMoneyStr = numeral(newVal).format('0,0.00');
    },
    reimburseMoney(newVal) {
      this.reimburseMoneyStr = numeral(newVal).format('0,0.00');
    }
  }


}
</script>

<style lang="less" scoped>
@import '../../../global';

.department-name {
  font-size: @fontSizeXX;
}

</style>

<style lang="less" scoped>

.table-header {
  display: flex;
  border-bottom: 1px solid #ebeef5;
  padding: 10px 0;
}

.header-cell {
  flex: 1;
  text-align: center;
  font-weight: bold;
}

.table-body {
  border: 1px solid #ebeef5;
}

.table-row {
  border-bottom: 1px solid #ebeef5;
}

.row-content {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.row-cell {
  flex: 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.expand-row {
  width: 100%;
  padding: 10px;
  background-color: #f9f9f9;
  border-top: 1px solid #ebeef5; /* 添加分割线 */
}

.expand-content {
  padding: 10px;
}

.clearfix {
  background-color: #F5F7FA;
  color: black;
}

.el-card {
  border-radius: 5px;
  --el-card-padding: 0px;
  margin-left: 10px;
  overflow: hidden;
}

.text-item {
  font-size: 15px;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 40px;
}

.el-header {
  --el-header-height: 30px;
}

.startPageClass {
  color: #00afff;
  margin-left: 30px;
  width: 400px;
  justify-content: left
}

.box {
  padding-top: 10px;
  border: 1px solid black;
  border-radius: 5px;
  border-color: #cccccc;
  margin: 10px 0;
}

.table-desc-style {
  margin: 10px 0;
}

.total-row {
  margin-top: 20px;
  margin-right: 30px;
  padding: 10px;
  font-size: 16px;
  font-weight: bold;
  background-color: white;
  display: flex;
  justify-content: flex-end;
}

.total-label {
  margin-right: 10px;
}

.total-value {
  color: #ff6a00;
}

</style>